import { colors } from '@/theme/colors';
interface ChevronRightProps {
  width?: number;
  height?: number;
  className?: string;
  fill?: string;
}

export default function ChevronRight({
  width = 24,
  height = 24,
  fill = colors.neutral10,
  className,
}: ChevronRightProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      className={className}
    >
      <path
        fill={fill}
        fillRule="nonzero"
        d="M7.962 4.477a.75.75 0 0 1 .976-.086l.085.071 6.859 6.67a1.21 1.21 0 0 1 .094 1.633l-.094.102-6.86 6.67a.75.75 0 0 1-1.119-.992l.074-.083L14.622 12 7.977 5.538a.75.75 0 0 1-.086-.976l.071-.085z"
      ></path>
    </svg>
  );
}
